<template>
  <v-text-field
    :value="value"
    @input="value => emit(value)"
    :type="config.type || 'text'"
    :label="config.label"
    :disabled="config.disabled"
    :name="config.key"
    :required="config.required"
    :id="config.key"
    :auto-grow="config.authoGrow"
    :multi-line="config.multiLine"
    :counter="config.counter"
    :error="haveErrors()"
    :rules="config.errors"
    :max="config.max"
    :hint="config.hint"
    :persistent-hint="config.persistentHint"
    :suffix="config.suffix">
  </v-text-field>
</template>

<script>
  import input from '@/mixins/input'
  export default {
    mixins: [input]
  }
</script>



// WEBPACK FOOTER //
// src/components/inputs/Text.vue